<template>
  <div>
    <Chip
      v-for="(psuTypeLabel, psuType) in psuTypeLabels"
      :key="`psu-type-${psuType}`"
      name="psu-type"
      :title="psuTypeLabel"
      :value="psuType"
      :checked="selectedPsuType === psuType"
      v-on:change="setPsuType"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { psuTypes } from '../../constants'
import Chip from '../elements/Chip'
import { SET_PERSONAL_STATE_VALUE } from '../../store/modules/personal/variables'

export default {
  data() {
    return {
      psuTypes,
      psuTypeLabels: {
        [psuTypes.personal]: 'Personal',
        [psuTypes.business]: 'Business'
      }
    }
  },
  components: {
    Chip
  },
  computed: {
    ...mapState('personal', ['selectedPsuType'])
  },
  methods: {
    ...mapMutations('personal', [SET_PERSONAL_STATE_VALUE]),
    setPsuType(val) {
      localStorage.setItem('selectedPsuType', val)
      this[SET_PERSONAL_STATE_VALUE](['selectedPsuType', val])
    }
  }
}
</script>
